import { ModelStory } from '../types';
import { storiesPart1 } from './stories-part1';
import { storiesPart2 } from './stories-part2';

// Combine all stories
export const modelStories: Record<string, ModelStory> = {
  ...storiesPart1,
  ...storiesPart2
};

export default modelStories;
